<template>
    <div>
        <el-dialog top="5%" title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="投票名称" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                 <el-form-item label="候选人"> 
                    <el-checkbox-group v-model="checkList" @change="getCheck">
                     <el-checkbox
                             v-for="item in checkboxOption"
                             :key="item.FID"
                             :label="item.FID"
                      >{{item.FName}}</el-checkbox>
                     </el-checkbox-group>
                </el-form-item>
                 <el-form-item label="开始时间" prop="FStartTime" >
                    <el-date-picker type="datetime" placeholder="选择时间" v-model="form.FStartTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="FEndTime" >
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="form.FEndTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                  <el-form-item label="选择人数" prop="FNum">
                    <el-input type="number" v-model="form.FNum" :min="1"></el-input>
                </el-form-item>
                 <el-form-item label="积分" prop="FScore">
                    <el-input type="number" v-model="form.FScore" :min="1"></el-input>
                </el-form-item>
                   <el-form-item label="是否选中奖励" prop="FIsSelReward" >
                   <el-radio-group v-model="form.FIsSelReward">
                        <el-radio :label="0" >选中不奖励</el-radio>
                        <el-radio :label="1" >选中奖励</el-radio> 
                    </el-radio-group>
                </el-form-item>
                 <el-form-item label="状态" prop="FStatus" >
                   <el-radio-group v-model="form.FStatus">
                        <el-radio :label="0" >待开启</el-radio>
                        <el-radio :label="1" >进行中</el-radio> 
                        <el-radio :label="2" >已结束</el-radio> 
                    </el-radio-group>
                </el-form-item>
                  <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    export default {
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '投票名称', trigger: 'blur'}],
                     FNum: [{required: true,message: '选择人数', trigger: 'blur'}],
                    FStartTime: [{required: true,message: '开始时间', trigger: 'blur'}],
                    FEndTime: [{required: true,message: '结束时间', trigger: 'blur'}]
                },
                loading:false,
                editFormVisible:false,
                checkboxOption:[],
                checkList:[],
                idList:[]
            }
        },
        methods: {
             getCheck() {
               console.log("checkList", this.checkList);
            },
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
                this.checkList = this.form.FCandidate.split(',').map(Number)
                console.log(this.checkList)
                 this._initcheck('edit')
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = {FID:0,FStatus:0,FNum:1,FScore:0,FIsSelReward:1};
                this._initcheck('add')
            },
            switchLoading(flag){
                this.loading = flag;
            },
            save:function () {
                 if(this.checkList.length==0){
                      util.msgWarning("请勾选投票候选人")
                      return 
                 }
                this.form.FCandidate = this.checkList.join(',');         
                let ids=[]
                for(let i=0;i<this.checkList.length;i++){
                    for(let j=0;j<this.checkboxOption.length;j++){
                        if(this.checkboxOption[j].FID==this.checkList[i]){
                             ids.push(this.checkboxOption[j].FName)
                             break;
                        }
                    }
                }
                this.form.FCandidateNames = ids.join(',');
                util.saveForm("server/business/Vote.ashx?cmd=Save",this.$refs.form,this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            },
            _initcheck(type){
                 let _that = this
                 let url = "server/system/User.ashx?cmd=GetUserOptions1"
                 util.get(url,{},this.switchLoading,result=> {
                     _that.checkboxOption = result.options
                     if(type=='add'){
                     result.options.map((item)=>{
                        _that.checkList.push(item.FID)
                     })
                     }
                 })
            }
        },
        mounted() {
           
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Vote_Edit.vue